<div class="fuse-card auto-width mb-12 mat-card mat-elevation-z2 p-0" [ngClass.gt-sm]="'mb-0 mr-12 p-0 m-r-6 m-b-6'">
    <div class="title-height" fxLayout="row" fxLayoutAlign="space-between center">
        <div fxLayout="row">
            <h3 class="pr-16 cardHeader">Baja</h3>

            <span *ngIf="SelectedLeaveDetail.Prioritaria === 'S'" class="priority-label m-l-5">Prioritaria</span>
        </div>

        <div *ngIf="!employeeService.isEmployeeLocked && isLeaveSelected" fxLayout="row">
            <!-- Display Applied Marks -->
            <div class="marcas-batches">
                <ng-container *ngIf="SelectedLeaveDetail.Marcas !== null">
                    <ng-container *ngIf="sharedService.Permissions.HasPermisos212">
                        <span matTooltip="Marca de Empresa" *ngIf="SelectedLeaveDetail.Marcas.includes('E')"
                            class="lbl3">E</span>
                        <span matTooltip="Marca de Médico" *ngIf="SelectedLeaveDetail.Marcas.includes('M')"
                            class="lbl4">M</span>
                        <span matTooltip="Marca de Coordinador" *ngIf="SelectedLeaveDetail.Marcas.includes('C')"
                            class="lbl2">C</span>
                        <span matTooltip="Marca de Mutua" *ngIf="SelectedLeaveDetail.Marcas.includes('U')"
                            class="lbl8">U</span>
                        <span matTooltip="Marca de Diagnóstico" *ngIf="SelectedLeaveDetail.Marcas.includes('D')"
                            class="lbl7">D</span>
                        <span matTooltip="Marca de Zona" *ngIf="SelectedLeaveDetail.Marcas.includes('Z')"
                            class="lbl7">Z</span>
                        <span matTooltip="Marca de Simulación" *ngIf="SelectedLeaveDetail.Marcas.includes('S')"
                            class="lbl7">S</span>
                        <span matTooltip="Marca de Salud Mental" *ngIf="SelectedLeaveDetail.Marcas.includes('L')"
                        class="lbl7">L</span>
                    </ng-container>

                    <ng-container *ngIf="sharedService.Permissions.HasPermisos223">
                        <span matTooltip="Marca externa" *ngIf="SelectedLeaveDetail.Marcas.includes('X')"
                            class="lbl7">X</span>
                    </ng-container>
                </ng-container>

                <ng-container *ngIf="sharedService.Permissions.HasPermisos306">
                    <span matTooltip="Puesto urgente" *ngIf="employee?.puestoUrgente === 'S'" class="lbl6">URG</span>
                </ng-container>
                <ng-container *ngIf="sharedService.Permissions.HasPermisos515">
                    <span matTooltip="Embarazada" *ngIf="SelectedLeaveDetail.Embarazada === 'S'" class="lbl6">EMB</span>
                </ng-container>
                <ng-container *ngIf="sharedService.Permissions.HasPermisos350">
                    <span matTooltip="Absentista" *ngIf="employee?.absentista === 'S'" class="lbl6">ABS</span>
                </ng-container>

                <span matTooltip="No visitar" *ngIf="SelectedLeaveDetail.NoVisitar === 'S'" class="lbl6">NO</span>
                <span matTooltip="Recaída" *ngIf="SelectedLeaveDetail.Recaida === 'S'" class="lbl6">Recaida</span>
            </div>

            <button mat-icon-button *ngIf="showEdit" (click)="OpenEditDialog()" tabindex="-1" [disabled]="isLoading">
                <mat-icon class="mat-icon material-icons mat-icon-no-color f-s-19">edit</mat-icon>
            </button>

            <!-- Operaciones -->
            <!-- <div class="vert-icon-header" *ngIf="showMenu">
                <span [matMenuTriggerFor]="employeeDocumentOptions">
                    <mat-icon
                        class="mat-icon material-icons mat-icon-no-color color-blueviolet doc-option"
                        role="img"
                        aria-hidden="true"
                    >
                        keyboard_arrow_down
                    </mat-icon>
                </span>
                <mat-menu #employeeDocumentOptions="matMenu">
                    <h5 class="p-l-10 mb-4 mt-4 font-bold">Operaciones</h5>
                    <mat-divider></mat-divider>
                    <button
                        mat-menu-item
                        *ngIf="
                            SelectedLeaveDetail.TipoChar === 'I' &&
                            sharedService.Permissions.HasPermisos601
                        "
                        (click)="PasarBajaClickHandler()"
                    >
                        Pasar a baja
                    </button>
                    <button
                        mat-menu-item
                        *ngIf="
                            !SelectedLeaveDetail.FAlta &&
                            sharedService.Permissions.HasPermisos612
                        "
                        [routerLink]="[
                            '/employee/create-discharge',
                            SelectedLeaveDetail.LeaveId,
                            LeaveOperations.Alta
                        ]"
                    >
                        Alta
                    </button>
                    <button
                        mat-menu-item
                        *ngIf="
                            !SelectedLeaveDetail.FAlta &&
                            sharedService.Permissions.HasPermisos612
                        "
                        [routerLink]="[
                            '/employee/create-discharge',
                            SelectedLeaveDetail.LeaveId,
                            LeaveOperations.ConfirmarDatos
                        ]"
                    >
                        Confirmar Datos
                    </button>
                    <button
                        mat-menu-item
                        *ngIf="
                            !SelectedLeaveDetail.FAlta &&
                            sharedService.Permissions.HasPermisos612
                        "
                        [routerLink]="[
                            '/employee/create-discharge',
                            SelectedLeaveDetail.LeaveId,
                            LeaveOperations.AltaNoConfirmada
                        ]"
                    >
                        Alta No Confirmada
                    </button>
                    <button
                        mat-menu-item
                        *ngIf="sharedService.Permissions.HasPermisos608"
                        (click)="openChangeLeaveTypeDialog()"
                    >
                        Cambiar tipo
                    </button>
                    <button
                        mat-menu-item
                        *ngIf="
                            sharedService.Permissions.HasPermisos620 &&
                            actuationService.areActionCutDataAvailable()
                        "
                        (click)="pasteActions(SelectedLeaveDetail.LeaveId)"
                    >
                        Pegar actuaciones
                    </button>
                    <button
                        mat-menu-item
                        (click)="onClickPrioritaria()"
                    >
                        {{prioritaria}}
                    </button>
                    <button
                        mat-menu-item
                        *ngIf="sharedService.Permissions.HasPermisos615"
                        (click)="DeleteLeave()"
                    >
                        Eliminar
                    </button>
                </mat-menu>
            </div> -->

            <!-- Marcas Dropdown -->
            <div class="vert-icon-header" *ngIf="
          !SelectedLeaveDetail.FAlta &&
          (sharedService.Permissions.HasPermisos212 ||
              sharedService.Permissions.HasPermisos223)
      ">
                <span [matMenuTriggerFor]="employeeMarcas">
                    <mat-icon class="mat-icon material-icons mat-icon-no-color color-blueviolet doc-option" role="img"
                        aria-hidden="true">
                        more_vert
                    </mat-icon>
                </span>


                <mat-menu class="employee-marcas-menu-panel" #employeeMarcas="matMenu">
                    <h5 class="p-l-10 mb-4 mt-4 font-bold">Marcas</h5>
                    <mat-divider></mat-divider>
                    <div class="table-column-toggle-menu">
                        <mat-checkbox class="no-check" *ngFor="
                      let marca of marcaOptionList
                          | listFilter: 'ISPERMIT':true;
                      let i = index
                  " (change)="
                      toggleMarca(
                          SelectedLeaveDetail,
                          marca,
                          $event.checked
                      )
                  " [checked]="
                      SelectedLeaveDetail.Marcas &&
                      SelectedLeaveDetail.Marcas.includes(marca.label)
                  ">
                            <span [class]="marca.className">{{
                                marca.label
                                }}</span>
                            {{ marca.text }}
                        </mat-checkbox>
                    </div>


                    <h5 class="p-l-10 mb-4 mt-5 font-bold">Operaciones</h5>
                    <mat-divider></mat-divider>
                    <button mat-menu-item *ngIf="
                  SelectedLeaveDetail.TipoChar === 'I' &&
                  sharedService.Permissions.HasPermisos601
              " (click)="PasarBajaClickHandler()">
                        Pasar a baja
                    </button>
                    <button mat-menu-item *ngIf="
                  !SelectedLeaveDetail.FAlta &&
                  sharedService.Permissions.HasPermisos612
              " [routerLink]="[
                  '/employee/create-discharge',
                  SelectedLeaveDetail.LeaveId,
                  LeaveOperations.Alta
              ]">
                        Alta
                    </button>
                    <button mat-menu-item *ngIf="
                  !SelectedLeaveDetail.FAlta &&
                  sharedService.Permissions.HasPermisos612
              " [routerLink]="[
                  '/employee/create-discharge',
                  SelectedLeaveDetail.LeaveId,
                  LeaveOperations.ConfirmarDatos
              ]">
                        Confirmar Datos
                    </button>
                    <button mat-menu-item *ngIf="
                  !SelectedLeaveDetail.FAlta &&
                  sharedService.Permissions.HasPermisos612
              " [routerLink]="[
                  '/employee/create-discharge',
                  SelectedLeaveDetail.LeaveId,
                  LeaveOperations.AltaNoConfirmada
              ]">
                        Alta No Confirmada
                    </button>
                    <button mat-menu-item *ngIf="sharedService.Permissions.HasPermisos608"
                        (click)="openChangeLeaveTypeDialog()">
                        Cambiar tipo
                    </button>
                    <button mat-menu-item *ngIf="
                  sharedService.Permissions.HasPermisos620 &&
                  actuationService.areActionCutDataAvailable()
              " (click)="pasteActions(SelectedLeaveDetail.LeaveId)">
                        Pegar actuaciones
                    </button>
                    <button mat-menu-item (click)="onClickPrioritaria()">
                        {{prioritaria}}
                    </button>
                    <button mat-menu-item *ngIf="sharedService.Permissions.HasPermisos615" (click)="DeleteLeave()">
                        Eliminar
                    </button>
                </mat-menu>
            </div>


            <!-- Marcas Dropdown Skip Alta -->
            <div class="vert-icon-header" *ngIf="
            SelectedLeaveDetail.FAlta &&
         (sharedService.Permissions.HasPermisos212 ||
              sharedService.Permissions.HasPermisos223)
      ">
                <span [matMenuTriggerFor]="employeeMarcas">
                    <mat-icon class="mat-icon material-icons mat-icon-no-color color-blueviolet doc-option" role="img"
                        aria-hidden="true">
                        more_vert
                    </mat-icon>
                </span>


                <mat-menu class="employee-marcas-menu-panel" #employeeMarcas="matMenu">
                    <h5 class="p-l-10 mb-4 mt-4 font-bold">Marcas</h5>
                    <mat-divider></mat-divider>
                    
                    <button mat-menu-item (click)="onClickPrioritaria()">
                        {{prioritaria}}
                    </button>
                    <h5 class="p-l-10 mb-4 mt-4 font-bold">Operaciones</h5>
                    <mat-divider></mat-divider>
                    <button mat-menu-item *ngIf="sharedService.Permissions.HasPermisos608"
                        (click)="openChangeLeaveTypeDialog()">
                        Cambiar tipo
                    </button>
                    <button mat-menu-item *ngIf="
                  sharedService.Permissions.HasPermisos620 &&
                  actuationService.areActionCutDataAvailable()
              " (click)="pasteActions(SelectedLeaveDetail.LeaveId)">
                        Pegar actuaciones
                    </button>
                    <button mat-menu-item *ngIf="sharedService.Permissions.HasPermisos615" (click)="DeleteLeave()">
                        Eliminar
                    </button>
                    <button mat-menu-item *ngIf="sharedService.Permissions.HasPermisos13" (click)="ReabrirBaja()">
                        Reabrir Baja
                    </button>
                </mat-menu>
            </div>
        </div>
    </div>
    <div class="p-10 pt-0 h-140">
        <div *ngIf="!isLoading && isLeaveSelected">
            <table class="border-none">
                <caption></caption>
                <thead>
                    <th></th>
                </thead>
                <tr>
                    <td>
                        <span class="f-w-600 m-r-5" *ngIf="SelectedLeaveDetail.Tipo != null">{{ SelectedLeaveDetail.Tipo
                            }}:
                            <span>{{
                                SelectedLeaveDetail.FBaja | date: 'dd/MM/yyyy'
                                }}</span>
                            <span *ngIf="SelectedLeaveDetail.FAlta !== undefined">
                                …
                                {{
                                SelectedLeaveDetail.FAlta
                                | date: 'dd/MM/yyyy'
                                }}</span>
                        </span>
                        <span *ngIf="
                                SelectedLeaveDetail.Recaida != null &&
                                SelectedLeaveDetail.Recaida === 'S'
                            " [ngClass]="
                                SelectedLeaveDetail.Recaida == 'S' ? 'lbl4' : ''
                            " class="lbl4 m-l-5">Recaída</span>
                    </td>
                </tr>
            </table>
            <table class="border-none m-b-5">
                <caption></caption>
                <thead>
                    <th></th>
                </thead>
                <tr>
                    <td>
                        <span style="color: red; font-weight: bold;"  *ngIf="SelectedLeaveDetail.FCierre != null" >Fecha de Cierre: {{ SelectedLeaveDetail.FCierre | date: 'dd/MM/yyyy' }}</span>
                    </td>
                </tr>
                <tr>
                    <td>
                        <span *ngIf="SelectedLeaveDetail.AvisoBaja != null">Avisos:
                            {{
                            SelectedLeaveDetail.AvisoBaja
                            | date: 'dd/MM/yyyy'
                            }}
                            ({{ SelectedLeaveDetail.DateDiffBaja }}
                            <span>{{ SelectedLeaveDetail.BajaDia }}</span>)</span>
                        <span *ngIf="
                                SelectedLeaveDetail.AvisoAlta != null ||
                                SelectedLeaveDetail.DateDiffAlta != null
                            ">
                            ..
                            {{
                            SelectedLeaveDetail.AvisoAlta
                            | date: 'dd/MM/yyyy'
                            }}
                        </span>
                        <span *ngIf="SelectedLeaveDetail.DateDiffAlta > 0">({{ SelectedLeaveDetail.DateDiffAlta }}
                            {{ SelectedLeaveDetail.AltaDia }})</span>
                    </td>
                </tr>
                <tr>
                    <td>
                        <span *ngIf="SelectedLeaveDetail.Dias != null">{{ SelectedLeaveDetail.Dias }} días de
                            baja.</span>
                        <span *ngIf="SelectedLeaveDetail.Fpa != null">
                            FPA: {{ SelectedLeaveDetail.Fpa }}</span>
                        <span *ngIf="
                                SelectedLeaveDetail.FAlta === null &&
                                SelectedLeaveDetail.Fpa != null
                            ">
                            ({{ SelectedLeaveDetail.DateDiffFpa }}
                            {{ SelectedLeaveDetail.FpaDia }}).</span>
                        <span class="m-l-5 lbl1" *ngIf="
                                SelectedLeaveDetail.Justificada === 'N' ||
                                SelectedLeaveDetail.Justificada === 'A'
                            ">
                            <ng-container *ngIf="SelectedLeaveDetail.Justificada === 'N'">NO JUSTIFICADA</ng-container>
                            <ng-container *ngIf="SelectedLeaveDetail.Justificada === 'A'">JUSTIFICADA CON ALERTA
                            </ng-container>
                        </span>
                    </td>
                </tr>
                <tr>
                    <td>
                        <span *ngIf="SelectedLeaveDetail.leaveRef != null">Referencia de Baja: {{ SelectedLeaveDetail.leaveRef }}</span>
                    </td>
                </tr>


            </table>
            <table class="border-none m-b-5">
                <caption></caption>
                <thead>
                    <th></th>
                </thead>
                <tr *ngIf="showForthRow">
                    <td>
                        {{ SelectedLeaveDetail.CodDiagnostico }}
                        <span *ngIf="SelectedLeaveDetail.Diagnostico != null">– {{ SelectedLeaveDetail.Diagnostico
                            }}</span>
                        <span class="m-l-5" *ngIf="SelectedLeaveDetail.Agudo != null" [ngClass]="
                                SelectedLeaveDetail.Agudo == 'S'
                                    ? 'lbl3'
                                    : 'dont-display'
                            ">
                            Agudo
                        </span>
                        <span class="m-l-5" *ngIf="SelectedLeaveDetail.Cronico != null" [ngClass]="
                                SelectedLeaveDetail.Cronico == 'S'
                                    ? 'lbl3'
                                    : 'dont-display'
                            ">
                            Crónico
                        </span>
                        <span class="m-l-5" *ngIf="SelectedLeaveDetail.Cirujia != null" [ngClass]="
                                SelectedLeaveDetail.Cirujia == 'S'
                                    ? 'lbl2'
                                    : 'dont-display'
                            ">
                            Cirugía
                        </span>
                        <span class="m-l-5" *ngIf="SelectedLeaveDetail.Embarazada != null" [ngClass]="
                                SelectedLeaveDetail.Embarazada == 'S'
                                    ? 'lbl5'
                                    : 'dont-display'
                            ">
                            Embarazada
                        </span>
                    </td>
                </tr>
            </table>
            <table class="border-none m-b-5">
                <caption></caption>
                <thead>
                    <th></th>
                </thead>
                <tr>
                    <td>
                        <span *ngIf="
                                SelectedLeaveDetail.RiesgosPsicosociales != null
                            ">Riesgos psicosociales:
                            {{ SelectedLeaveDetail.RiesgosPsicosociales }}
                        </span>
                        <span class="m-l-5" *ngIf="
                                SelectedLeaveDetail.Actitud != null &&
                                SelectedLeaveDetail.Actitud === 'NEGATIVA'
                            " [ngClass]="
                                SelectedLeaveDetail.Actitud == 'NEGATIVA'
                                    ? 'lbl1'
                                    : ''
                            ">Actitud Negativa</span>
                    </td>
                </tr>
            </table>
        </div>
    </div>
    <div *ngIf="isLoading" class="m-auto">
        <mat-progress-spinner class="m-auto" [diameter]="50" color="primary" mode="indeterminate">
        </mat-progress-spinner>
    </div>
</div>